<template>
	<ul
		:class="{ active: expanded }"
		:aria-activedescendant="selectedOption.id"
		:aria-labelledby="labelledBy"
		tabindex="-1"
		role="listbox"
		ref="list"
		@keydown.enter.prevent="close"
		@keydown.esc.prevent="close"
		@keydown.home.prevent="selectFirst"
		@keydown.end.prevent="selectLast"
		@keydown.down.prevent="selectDown"
		@keydown.up.prevent="selectUp"
	>
		<slot />
	</ul>
</template>

<script>
import Vue from "vue";
import { plugins } from "@vg-faset/core";
import { SelectList } from "../mixins";

Vue.use(plugins.keyCodeAliases);

export default {
	name: "SelectList",

	mixins: [SelectList]
};
</script>
